// Exact tests for the declared G07.1 model proxies; never tessellated render meshes.
const pointBounds = p => ({ minX: p.x, minZ: p.z, maxX: p.x, maxZ: p.z });
export function queryGeometryBounds(g) {
  if (g.kind === 'point') return pointBounds(g.point);
  if (g.kind === 'segment') return { minX: Math.min(g.start.x, g.end.x), minZ: Math.min(g.start.z, g.end.z),
    maxX: Math.max(g.start.x, g.end.x), maxZ: Math.max(g.start.z, g.end.z) };
  const dx = Math.abs(g.axis.x) * g.halfX + Math.abs(g.axis.z) * g.halfZ;
  const dz = Math.abs(g.axis.z) * g.halfX + Math.abs(g.axis.x) * g.halfZ;
  return { minX: g.center.x - dx, minZ: g.center.z - dz, maxX: g.center.x + dx, maxZ: g.center.z + dz };
}
export function queryHitMatches(g, p, tolerance) {
  if (g.kind === 'point') return Math.hypot(p.x - g.point.x, p.z - g.point.z) <= tolerance;
  if (g.kind === 'segment') {
    const dx = g.end.x - g.start.x, dz = g.end.z - g.start.z;
    const lengthSquared = dx * dx + dz * dz;
    const t = lengthSquared ? Math.max(0, Math.min(1, ((p.x - g.start.x) * dx + (p.z - g.start.z) * dz) / lengthSquared)) : 0;
    return Math.hypot(p.x - g.start.x - t * dx, p.z - g.start.z - t * dz) <= tolerance;
  }
  const dx = p.x - g.center.x, dz = p.z - g.center.z;
  // Rectangular padding preserves the wall/door longitudinal AND normal tolerance.
  return Math.abs(dx * g.axis.x + dz * g.axis.z) <= g.halfX + tolerance
    && Math.abs(-dx * g.axis.z + dz * g.axis.x) <= g.halfZ + tolerance;
}
export function queryBoxMatches(b, r, mode) {
  return mode === 'crossing'
    ? b.minX <= r.maxX && b.maxX >= r.minX && b.minZ <= r.maxZ && b.maxZ >= r.minZ
    : b.minX >= r.minX && b.maxX <= r.maxX && b.minZ >= r.minZ && b.maxZ <= r.maxZ;
}
